<div class="context-menu-container" #ContextMenuContainer [style.top.px]="location.y" [style.left.px]="location.x"
  [ngClass]="{expanded: isOpen}" (click)="$event.stopPropagation()">
  <div class="expandable-tool-container" *ngFor="let expandableTool of expandableTools">
    <div class="tool-container">
      <span [ngClass]="expandableTool.tools[expandableTool.defaultIndex].icon+ ' ' + expandableTool.tools[expandableTool.defaultIndex].color"></span>
      <span class="ps-3">{{expandableTool.name}}</span>
      <span class="arrow-container">
        <svg width="12" height="5" viewBox="0 0 15 6" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M7.12196 5.6462C7.45323 5.86137 7.88011 5.86137 8.21137 5.6462L14.0735 1.83863C14.9085 1.29632 14.5244 0 13.5288 0L1.80452 0C0.808912 0 0.424872 1.29632 1.25982 1.83863L7.12196 5.6462Z"
            fill="white" />
        </svg>
      </span>
    </div>
    <div class="sub-tool-container" [classList]="subToolsClassList">
      <div class="tool-container big clickable" [ngClass]='{"disabled-tool":tool.disabled}' *ngFor="let tool of expandableTool.tools" (click)="sendActivateTool(tool)">
        <span [ngClass]="tool.icon+ ' ' + tool.color"></span>
        <span class="ps-3">{{tool.name}}</span>
      </div>
    </div>
    <!-- <div class="collapsable-tool row g-0 clickable" *ngFor='let tool of expandableTool.tools'
      [ngClass]='{"disabled-tool":tool.disabled}'
      (click)='clickExpandableTool(tool.func,tool.args)'>
      <div class="col-3 collapsable-tool-icon d-flex justify-content-center align-items-center">
        <span [ngClass]="tool.icon + ' ' + tool.color"></span>
      </div>
      <div class="col-9 d-flex align-items-center">
        <span>{{tool.name}}</span>
      </div>
    </div> -->
  </div>
</div>